import { WebsocketInstanceI } from "@/lib/types/websockets";
import { ValueOfObjectFields } from "shared/lib/interfaces/utils";
import { WEBSOCKET_CONNECTION_TYPES } from "lib/websockets/constants";
import { GLOBAL_WS_INSTANCES } from "@/constants/window-globals";

type WebsocketConnectionTypeI = ValueOfObjectFields<
  typeof WEBSOCKET_CONNECTION_TYPES
>;

export const setWebsocketInstance = (
  connectionType: WebsocketConnectionTypeI,
  ws: WebSocket
) => {
  const wsInstances: Record<WebsocketConnectionTypeI, WebSocket> =
    (<any>window)?.[GLOBAL_WS_INSTANCES] || {};

  wsInstances[connectionType] = ws;

  (<any>window)[GLOBAL_WS_INSTANCES] = wsInstances;
};

export const getWebsocketInstance = (
  connectionType: WebsocketConnectionTypeI
) => {
  return (<any>window)?.[GLOBAL_WS_INSTANCES]?.[
    connectionType
  ] as WebsocketInstanceI;
};
